import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';

class FieldsSetsListComponent extends Component {
    /**
     * Compara si los columnas seleccionados coinciden exactamente con un set de columnas
     * @param {Object} fieldsSet - El set de columnas a comparar
     * @param {Array} currentDimensions - Dimensiones actualmente seleccionadas
     * @param {Array} currentMetrics - Métricas actualmente seleccionadas
     * @param {Object} fieldsData - Datos de los columnas para separar dimensions y metrics
     * @returns {boolean} - true si coinciden exactamente en contenido y orden
     */
    fieldsMatchSet(fieldsSet, currentDimensions, currentMetrics, fieldsData) {
        if (!fieldsData || !fieldsSet.fields || fieldsSet.fields.length === 0) {
            return false;
        }

        // Separar los fields del set en dimensions y metrics
        const setDimensions = [];
        const setMetrics = [];

        fieldsSet.fields.forEach(fieldId => {
            const fieldData = fieldsData.FIELD_DATA_BY_ID[fieldId];
            if (fieldData) {
                if (fieldData.segment === fieldsData.FIELD_SEGMENTS.DIMENSIONS) {
                    setDimensions.push(fieldId);
                } else if (fieldData.segment === fieldsData.FIELD_SEGMENTS.METRICS) {
                    setMetrics.push(fieldId);
                }
            }
        });

        // Comparar arrays: deben tener la misma longitud y los mismos elementos en el mismo orden
        const arraysEqual = (arr1, arr2) => {
            if (arr1.length !== arr2.length) return false;
            return arr1.every((val, index) => val === arr2[index]);
        };

        return arraysEqual(currentDimensions, setDimensions) && arraysEqual(currentMetrics, setMetrics);
    }

    handleSelectSet(fieldsSet) {
        if (this.props.onSelectFieldsSet) {
            this.props.onSelectFieldsSet(fieldsSet);
        }
    }

    handleDeleteSet(event, fieldsSet) {
        event.preventDefault();
        event.stopPropagation();
        if (this.props.onDeleteFieldsSet) {
            this.props.onDeleteFieldsSet(fieldsSet);
        }
    }

    render() {
        const { t, fieldsSets, dimensions, metrics, fieldsData, editingFieldsSet } = this.props;
        
        if (!fieldsSets || fieldsSets.length === 0) {
            return <p className="header-menu-message">{t('fields_sets_list.no_fields_sets_saved_yet', 'No hay sets de columnas guardados aún')}</p>;
        }

        // Ordenar sets alfabéticamente por nombre (case-insensitive)
        const sortedFieldsSets = [...fieldsSets].sort((a, b) => {
            const nameA = (a.name || '').toLowerCase();
            const nameB = (b.name || '').toLowerCase();
            return nameA.localeCompare(nameB);
        });

        return (
            <ul>
                {sortedFieldsSets.map((fieldsSet) => {
                    // Solo mostrar el checkmark si el set coincide exactamente Y es el set en edición
                    const matchesFields = this.fieldsMatchSet(fieldsSet, dimensions || [], metrics || [], fieldsData);
                    const isActive = matchesFields && editingFieldsSet && editingFieldsSet.id === fieldsSet.id;
                    
                    return (
                        <li key={fieldsSet.id}>
                            <button 
                                className="header-menu-list-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.handleSelectSet(fieldsSet);
                                }}
                            >
                                <span>
                                    {fieldsSet.name}
                                    {fieldsSet.is_shared && (
                                        <span className="text-muted" style={{ fontSize: '0.85em', marginLeft: '0.5rem' }}>
                                            ({t('fields_sets_list.shared', 'Compartido')})
                                        </span>
                                    )}
                                    {isActive && (
                                        <FaIcon 
                                            iconName="check" 
                                            style={{ 
                                                marginLeft: '0.5rem', 
                                                color: '#28a745',
                                                fontSize: '1em'
                                            }} 
                                        />
                                    )}
                                </span>
                                {!fieldsSet.is_shared && fieldsSet.created_by_user_id !== null && (
                                    <span
                                        className="header-menu-list-button-delete"
                                        onClick={(e) => this.handleDeleteSet(e, fieldsSet)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                this.handleDeleteSet(e, fieldsSet);
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                        title={t('fields_sets_list.delete_set', 'Borrar set')}
                                    >
                                        <FaIcon iconName="trash" />
                                    </span>
                                )}
                            </button>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

export const FieldsSetsList = withTranslation()(FieldsSetsListComponent);
export default FieldsSetsList;

